import { render, staticRenderFns } from "./EmployeeAddForm.vue?vue&type=template&id=3120be86&scoped=true&"
import script from "./EmployeeAddForm.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAddForm.vue?vue&type=style&index=0&id=3120be86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120be86",
  null
  
)

export default component.exports